import React, { useState, useEffect } from "react";
import "./index.css";

// Layout
import Navbar     from "./components/layout/Navbar";
import Footer     from "./components/layout/Footer";
import ChatWidget from "./components/layout/ChatWidget";

// Pages
import HomePage    from "./pages/HomePage";
import ProductsPage from "./pages/ProductsPage";
import ServicesPage from "./pages/ServicesPage";
import AboutPage    from "./pages/AboutPage";
import DemoPage     from "./pages/DemoPage";
import ContactPage  from "./pages/ContactPage";

const PAGES = {
  home:     HomePage,
  products: ProductsPage,
  services: ServicesPage,
  about:    AboutPage,
  demo:     DemoPage,
  contact:  ContactPage,
};

function App() {
  const [currentPage, setCurrentPage] = useState("home");

  const navigate = (page) => {
    if (!PAGES[page]) return;
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Update tab title
  useEffect(() => {
    const titles = {
      home:     "Eminent Solutions – AI-Driven Software Innovation",
      products: "Products – Eminent Solutions",
      services: "Services – Eminent Solutions",
      about:    "About Us – Eminent Solutions",
      demo:     "Demo – Eminent Solutions",
      contact:  "Contact – Eminent Solutions",
    };
    document.title = titles[currentPage] || "Eminent Solutions";
  }, [currentPage]);

  const PageComponent = PAGES[currentPage] || HomePage;

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar currentPage={currentPage} navigate={navigate} />

      <main className="flex-1">
        <PageComponent navigate={navigate} />
      </main>

      <Footer navigate={navigate} />
      <ChatWidget navigate={navigate} />
    </div>
  );
}

export default App;
